<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">Add Inner Mapping
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>

<div style="max-height: 15% !important;">
  <div class="row" style=" margin-top: -0.5rem">
    <div class="col-md-6 col-sm-6 col-lg-2" class="pull-right" *ngIf="showHotAlertSection">
      <mat-form-field class="hotalert">
        <input type="text" [(ngModel)]="hotAlert" matInput placeholder="Add Hot Alert" style="border: none !important;margin-top: -1rem;">
      </mat-form-field>
    </div>
    <div class="col-md-6 col-sm-6 col-lg-10" class="pull-right" *ngIf="showHotAlertSection">
      <button class="btn btn-semi-round w-30 bgBlue alertbtn pull-left" (click)="addHotAlert()" style="margin-left: 1rem;margin-top: 0rem ">
        Add
      </button>
      <!-- <button class="btn btn-semi-round w-30 bgBlue " (click)="onSave()" style="margin-top: 0rem; margin-left: 45rem; ">
        Save
      </button> -->
    </div>
    <!-- <div class="col-md-12" *ngIf="!showHotAlertSection">
      <button class="btn btn-semi-round w-30 bgBlue" (click)="onSave()" style="margin-left: 68rem ;" >
        Save
      </button>
    </div> -->
  </div>
  <div class="row" id="in" style="margin-top: 0.5rem;">
    <div class="col-md-3">
      <div class="section-heading">Inner Asset Columns</div>
    </div>
    <div class="col-md-3">
      <div class="section-heading">Inner Asset Mapped Columns</div>
    </div>
    <div class="col-md-3">
      <div class="section-heading">Inner File Mapped Columns</div>
    </div>
    <div class="col-md-3">
      <div class="section-heading">Inner File Columns</div>
    </div>
  </div>
  <div class="row" style="margin-left: -0.5rem;">
    <div class="col-md-3">
      <div class="drag-container drag-container-col-1">
        <div cdkDropList id="cdkInnerAssetColumnList" #cdkInnerAssetColumnList="cdkDropList"
          [cdkDropListData]="arrInnerAssetColumns" [cdkDropListConnectedTo]="[cdkMappedInnerAssetColumnList]"
          class="item-list" (cdkDropListDropped)="drop($event)">
          <div class="item-box" *ngFor="let item of arrInnerAssetColumns" cdkDrag>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
           {{item.description == null ? item.name : item.description}} 
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="container drag-container-col-2">
        <div class="row">
          <div class="col-md-6">
            <div class="drag-container">
              <div cdkDropList id="cdkMappedInnerAssetColumnList" #cdkMappedInnerAssetColumnList="cdkDropList"
                [cdkDropListData]="assetInnerMapping" [cdkDropListConnectedTo]="[cdkInnerAssetColumnList]"
                class="item-list" (cdkDropListDropped)="drop($event)">
                <div class="item-box" *ngFor="let item of assetInnerMapping">
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  {{item.innerTableColumnText}} <span class="heavy-multiplication"
                    (click)="removeInnerAssetColumn(item);" placement="top"
                    ngbTooltip="Remove Inner Mapping">&#10006;</span>
                  <span class="mapping-line"></span>
                </div>

              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="drag-container">
              <div cdkDropList id="cdkMappedInnerFileColumnList" #cdkMappedInnerFileColumnList="cdkDropList"
                [cdkDropListData]="assetInnerMapping" [cdkDropListConnectedTo]="[cdkInnerFileColumnList]"
                class="item-list" (cdkDropListDropped)="drop($event)">
                <div class="item-box" *ngFor="let item of assetInnerMapping">
                  <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                  {{item.innerFileColumn}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="drag-container drag-container-col-1">
        <div cdkDropList id="cdkInnerFileColumnList" #cdkInnerFileColumnList="cdkDropList"
          [cdkDropListData]="arrInnerFileColumns" [cdkDropListConnectedTo]="[cdkMappedInnerFileColumnList]"
          class="item-list" (cdkDropListDropped)="drop($event)">
          <div class="item-box" *ngFor="let item of arrInnerFileColumns" cdkDrag>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            {{item}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>